// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".additional-users-container {\n  background-color: #121212;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 17px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #afafaf;\n  width: 90px;\n  height: 35px;\n  border-radius: 6px;\n}\n", ""]);
// Exports
module.exports = exports;
